import React, { useEffect, useState } from "react";
import { Cell, Label, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import axiosInstance from "../../../../../Services/axiosCommon";
import { useNavigate } from "react-router-dom";

function QuotationToCustomer() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  async function getData() {
    setLoading(true);
    try {
      const res = await axiosInstance.get("/dashboard/CusQts-pending");
      setData(res?.data || []);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  }

  useEffect(() => {
    getData();
  }, []);

  const COLORS = ["#F59E0B", "#8B5CF6", "#10B981"];
  const chartData = [
    { name: "Pending", value: data?.pending || 0, status: "Pending" },
    { name: "Verified", value: data?.verified || 0, status: "Verified" },
    { name: "Approved", value: data?.approved || 0, status: "Approved" },
  ];

  const handleSliceClick = (status) => {
    const path = "/sales/quotes";
    navigate(path, { state: { approvalStatus: status } });
  };

  const sumValue = chartData.reduce((sum, value) => sum + (value?.value || 0), 0);

  return (
    <div className="bg-gray-50/60 p-4 rounded-xl border border-gray-100 flex flex-col justify-between">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-semibold text-gray-700">Quotation to Customer</span>
        <span className="text-[10px] font-bold px-2 py-0.5 rounded-full bg-purple-50 text-purple-700 border border-purple-200/50">
          {data?.total || 0} Total
        </span>
      </div>

      {loading ? (
        <div className="h-28 flex items-center justify-center animate-pulse">
          <div className="w-16 h-16 rounded-full bg-gray-200"></div>
        </div>
      ) : (
        <div className="flex items-center justify-between space-x-2 my-1">
          <div className="w-1/2 h-24 relative flex items-center justify-center">
            {sumValue > 0 ? (
              <ResponsiveContainer width="100%" height="100%">
                <PieChart>
                  <Pie
                    data={chartData}
                    cx="50%"
                    cy="50%"
                    innerRadius={24}
                    outerRadius={36}
                    dataKey="value"
                    stroke="none"
                    style={{ cursor: "pointer" }}
                    onClick={(e) => handleSliceClick(e.status)}
                  >
                    {chartData.map((entry, index) => (
                      <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                    ))}
                    <Label
                      value={`${data?.total || 0}`}
                      position="center"
                      style={{ fontSize: "12px", fontWeight: "bold", fill: "#1F2937" }}
                    />
                  </Pie>
                  <Tooltip
                    contentStyle={{
                      backgroundColor: "#1F2937",
                      borderRadius: "6px",
                      color: "#FFF",
                      border: "none",
                      fontSize: "11px",
                      padding: "4px 8px",
                    }}
                  />
                </PieChart>
              </ResponsiveContainer>
            ) : (
              <div className="text-xs text-gray-400 font-medium">0 Data</div>
            )}
          </div>

          <div className="w-1/2 space-y-1 text-xs">
            <button
              onClick={() => handleSliceClick("Pending")}
              className="w-full flex justify-between items-center p-1 rounded-lg bg-amber-50/60 hover:bg-amber-100/60 text-left transition-colors"
            >
              <span className="text-[9px] text-amber-700 font-medium">Pending</span>
              <span className="text-xs font-bold text-gray-800">{data?.pending || 0}</span>
            </button>

            <button
              onClick={() => handleSliceClick("Verified")}
              className="w-full flex justify-between items-center p-1 rounded-lg bg-purple-50/60 hover:bg-purple-100/60 text-left transition-colors"
            >
              <span className="text-[9px] text-purple-700 font-medium">Verified</span>
              <span className="text-xs font-bold text-gray-800">{data?.verified || 0}</span>
            </button>

            <button
              onClick={() => handleSliceClick("Approved")}
              className="w-full flex justify-between items-center p-1 rounded-lg bg-emerald-50/60 hover:bg-emerald-100/60 text-left transition-colors"
            >
              <span className="text-[9px] text-emerald-700 font-medium">Approved</span>
              <span className="text-xs font-bold text-gray-800">{data?.approved || 0}</span>
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default QuotationToCustomer;